import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPresentation1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 3C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5V16C21 17.1046 20.1046 18 19 18H13.9453L16.2382 20.2929C16.6287 20.6834 16.6287 21.3166 16.2382 21.7071C15.8476 22.0976 15.2145 22.0976 14.824 21.7071L11.9955 18.8787L9.1671 21.7071C8.77657 22.0976 8.14341 22.0976 7.75288 21.7071C7.36236 21.3166 7.36236 20.6834 7.75288 20.2929L10.0458 18H5C3.89543 18 3 17.1046 3 16V5C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H21ZM19 5H5V16H19V5ZM8 11C8.51283 11 8.93551 11.386 8.99327 11.8834L9 12V13C9 13.5523 8.55228 14 8 14C7.48717 14 7.06449 13.614 7.00673 13.1166L7 13V12C7 11.4477 7.44772 11 8 11ZM12 9C12.5523 9 13 9.44772 13 10V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V10C11 9.44772 11.4477 9 12 9ZM16 7C16.5128 7 16.9355 7.38604 16.9933 7.88338L17 8V13C17 13.5523 16.5523 14 16 14C15.4872 14 15.0645 13.614 15.0067 13.1166L15 13V8C15 7.44772 15.4477 7 16 7Z",
		fill: "currentColor"
	})
});
export default SvgPresentation1Line;
